import { ShieldCheck } from "lucide-react";
import Reveal from "@/components/Reveal";
import SectionTag from "@/components/SectionTag";
import { SITE } from "@/data/site";

export default function InsuranceSection() {
  return (
    <section data-testid="insurance-section" className="bg-slate-50/70">
      <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 md:py-28 lg:px-12">
        <Reveal className="max-w-2xl">
          <SectionTag number="04" label="Coverage" />
          <h2 className="mt-5 font-display text-2xl font-bold tracking-tight text-brand-navy sm:text-3xl lg:text-4xl">
            Insurance and{" "}
            <span className="font-serif italic text-brand-red">Self-Pay Options</span>
          </h2>
          <p className="mt-5 text-base leading-relaxed text-slate-600 sm:text-lg">
            We welcome patients with a wide range of plans—and self-pay
            patients too.
          </p>
        </Reveal>
        <div className="mt-10 flex flex-wrap gap-3">
          {SITE.insurance.map((plan, i) => (
            <Reveal key={plan} delay={i * 0.05}>
              <span
                data-testid={`insurance-chip-${plan.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className={`inline-flex items-center gap-2 rounded-full border px-5 py-2.5 text-sm font-medium transition-colors duration-300 ${
                  plan === "Self-Pay"
                    ? "border-brand-red bg-brand-redlight text-brand-red"
                    : "border-slate-200 bg-white text-slate-700 hover:border-brand-red/40"
                }`}
              >
                <ShieldCheck className={`h-4 w-4 ${plan === "Self-Pay" ? "text-brand-red" : "text-slate-400"}`} />
                {plan === "Self-Pay" ? "Self-Pay Welcome" : plan}
              </span>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2} className="mt-10 max-w-3xl">
          <div
            data-testid="out-of-network-section"
            className="rounded-3xl border border-slate-200 bg-white p-8"
          >
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-400">
              Out-of-Network
            </p>
            <h3 className="mt-3 font-display text-lg font-semibold text-brand-navy">
              Out-of-Network Insurance
            </h3>
            <div className="mt-4 flex flex-wrap gap-3">
              {SITE.outOfNetwork.map((plan) => (
                <span
                  key={plan}
                  data-testid={`out-of-network-chip-${plan.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className="inline-flex items-center rounded-full border border-dashed border-slate-300 bg-slate-50 px-5 py-2.5 text-sm font-medium text-slate-600"
                >
                  {plan}
                </span>
              ))}
            </div>
            <p
              data-testid="out-of-network-disclaimer"
              className="mt-4 text-sm leading-relaxed text-slate-500"
            >
              {SITE.outOfNetworkDisclaimer}
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.3}>
          <p data-testid="insurance-note" className="mt-8 max-w-2xl text-sm leading-relaxed text-slate-500">
            Coverage can vary by plan. Please call our office at{" "}
            <a href={SITE.phoneHref} data-testid="insurance-call-link" className="font-semibold text-brand-red hover:text-brand-redhover">
              {SITE.phone}
            </a>{" "}
            with questions before your appointment.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
